module.exports = __webpack_public_path__ + "img/m_ma.96854ea1.png";